import * as types from "./types";
import {
    createAccessrule,
    accessRuleList,
    editAccessrule,
} from "@/services/accessrule";

export default {
    async createAccessrule({ commit }, payload) {
        try {
            const data = await createAccessrule(payload);
            return data;
        } catch (error) {
            throw error;
        }
    },

    async accessRuleList({ commit }, payload) {
        try {
            const data = await accessRuleList(payload);
            commit(types.SET_ACCESSRULELIST, data.response);
            return data.response;
        } catch (error) {
            throw error;
        }
    },

    async editAccessrule ({commit}, payload){
        try{
            const data = await editAccessrule(payload);
            return data;
        } catch (error) {
            throw error;
        }
    },

    async setAccessObject({ commit }, payload) {
        try {
            commit(types.SET_ACCESSOBJECT, payload);
            return payload;
        } catch (error) {
            throw error;
        }
    },

};
